import type { IconNode } from '../types';

/**
 * @name numbers
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgNCAyLjYtMS45NWEuMjUuMjUgMCAwMS40LjJWMTAiIC8+CiAgPHBhdGggZD0iTTE2IDE0LjUzNUE0IDQgMCAwMTE4IDE0YTIgMiAwIDAxMCA0IDIgMiAwIDAxMCA0IDQgNCAwIDAxLTItLjUzNSIgLz4KICA8cGF0aCBkPSJNOCAyMkg0LjVhLjUuNSAwIDAxLS41LS41YzAtMi42OCA0LTIuOTMyIDQtNS41YTIgMiAwIDAwLTItMiAyLjUgMi41IDAgMDAtMiAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/numbers
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Numbers: IconNode = [
  ['path', { d: 'm10 4 2.6-1.95a.25.25 0 01.4.2V10' }],
  ['path', { d: 'M16 14.535A4 4 0 0118 14a2 2 0 010 4 2 2 0 010 4 4 4 0 01-2-.535' }],
  ['path', { d: 'M8 22H4.5a.5.5 0 01-.5-.5c0-2.68 4-2.932 4-5.5a2 2 0 00-2-2 2.5 2.5 0 00-2 1' }],
];

export default Numbers;
